module.exports = __webpack_public_path__ + "static/img/ken.cff0e26e.jpg";